import React, { useEffect, useState } from 'react';

import { isEmpty, isEqual } from 'lodash';

import { connect } from 'react-redux';

import Checkbox from '@material-ui/core/Checkbox';
import { 
    TreeList, 
    orderBy, 
    filterBy, 
    mapTree, 
    extendDataItem,
    TreeListTextFilter
} from '@progress/kendo-react-treelist';

import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as RoleActions from '../../../actions/roleActions';

import classes from '../CreateEntityModal.module.css';
import * as treeListClasses from '../TreeList.module.css';

const subItemsField = 'subItems';
const expandField = 'expanded';

const ContextualTab = ({
    activeNavCompany,
    companies,
    setExistingUserContext,
    fetchUserContextData,
    isCompanyLevelAccess,
    setIsCompanyLevelAccess,
    selectedUser,
    currentUser,
    contextState,
    setContextState,
    setUncheckedCompanyLevelAccess,
    setWorkBookMode,
    uncheckedCompanyLevelAccess,
    workbookModeEnabled,
}) => {
    const [isExpandAll, setIsExpandAll] = useState(false);
    const [originalData, setOriginalData] = useState([]);
    useEffect(() => {
        async function init() {
            const loggedInUserContextData = await fetchUserContextData(currentUser.id, activeNavCompany.id);
            const selectedUserContextData = await fetchUserContextData(selectedUser.id, activeNavCompany.id);
            setOriginalData(selectedUserContextData);

            if (selectedUserContextData) {
                // this is used to delete existing scope.
                setExistingUserContext(selectedUserContextData);

                let isFullAccess = isEqual(loggedInUserContextData, selectedUserContextData);

                if (isFullAccess) {
                    setIsCompanyLevelAccess(true);
                    setUncheckedCompanyLevelAccess(false);
                }

                loggedInUserContextData.clients.forEach(lClient => {
                    let tempClient = selectedUserContextData.clients.filter(c => c.id === lClient.id);
                    if (!isEmpty(tempClient)) {
                        lClient.checked = true;
                        lClient.isExisting = true;

                        lClient.subItems.forEach(lSite => {
                            let tempSite = tempClient[0].subItems.filter(s => s.id === lSite.id);
                            if (!isEmpty(tempSite)) {
                                lSite.checked = true;
                                lSite.isExisting = true;
                            }
                        });
                    }
                });
            }

            if (!isEmpty(loggedInUserContextData)) {
                let expandItems = loggedInUserContextData.clients.map(item => item.id);
                setIsExpandAll(true);

                setContextState({
                    data:      [ ...loggedInUserContextData.clients ],
                    dataState: {
                        sort: [{
                            field: 'name',
                            dir:   'asc'
                        }],
                        filter: []
                    },
                    expanded: [ ...expandItems ]
                });
            }
        }
    
        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);
    
    useEffect(() => {
        if (!isEmpty(contextState) && !workbookModeEnabled) {
            const { dataState } = contextState;
            dataState.filter = [];
            setContextState({
                ...contextState,
                dataState: dataState
            });
        }
    }, [workbookModeEnabled]);

    const onExpandChange = e => {
        setContextState({
            ...contextState,
            expanded: e.value ? contextState.expanded.filter(id => id !== e.dataItem.id) : [...contextState.expanded, e.dataItem.id]
        });
    };

    const addExpandField = dataTree => {
        const expanded = contextState.expanded;
        return mapTree(dataTree, subItemsField, item => extendDataItem(item, subItemsField, {
            [expandField]: expanded.includes(item.id)
        }));
    };

    const processData = () => {
        let {
            data,
            dataState
        } = contextState;
        let filteredData = filterBy(data, dataState.filter, subItemsField);
        let sortedData = orderBy(filteredData, dataState.sort, subItemsField);
        return addExpandField(sortedData);
    };

    const handleDataStateChange = event => {
        setContextState({
            ...contextState,
            dataState: event.dataState
        });
    };

    const hasRecordChanged = (isOriginal, isChecked) => {
        if (isOriginal && isChecked) {
            return false;
        }
        else if (isOriginal && !isChecked) {
            return true;
        }
        else if (!isOriginal && isChecked) {
            return true;
        }
        else {
            return false;
        }
    };

    const handleCheckboxChange = (e, dataItem) => {
        let tempData = contextState.data;
        let dataObj = {...dataItem};
        if (dataObj.isClient) {
            const client = contextState.data.filter(c => c.id === dataObj.id);
            
            if (client) {
                const { clients } = originalData;
                const isOriginalClient = clients.filter(c => c.id === dataObj.id).length !== 0;
                const isChanged = hasRecordChanged(isOriginalClient, !dataObj.checked);
                client[0].checked = dataObj.checked ? false : true;
                client[0].unchecked = client[0].checked ? false : true;
                client[0].isChanged = isChanged;

                // all sites should be set to the same checked state
                client[0].subItems.forEach(site => {
                    site.checked = client[0].checked;
                    site.unchecked = client[0].unchecked;
                    site.isChanged = site.isChanged ? !site.isChanged : true;
                });

                tempData = tempData.map(item => {
                    if (item.id === dataItem.id) {
                        item.checked = client[0].checked;
                        item.unchecked = client[0].unchecked;
                        item.isChanged = client[0].isChanged;
                        return item;
                    }
                    else {
                        return item;
                    }
                });
            }
        }
        else {
            const sites = contextState.data.filter(items => items.subItems.some(s => s.id === dataObj.id));
            const { clients } = originalData;
            const isOriginalClient = clients.filter(c => c.id === sites[0].id).length !== 0;
            const { subItems} = sites[0];
            const site = subItems.filter(s => s.id === dataObj.id);
            if (site) {
                const isChanged = hasRecordChanged(isOriginalClient, !dataObj.checked);
                site[0].checked = dataObj.checked ? false : true;
                site[0].unchecked = dataObj.unchecked ? false : true;
                site[0].isChanged = isChanged;
            }

            if (subItems.length === 1) {
                // set the client to same checked value;
                sites[0].checked = sites[0].subItems[0].checked;
                sites[0].unchecked = sites[0].subItems[0].unchecked;
                sites[0].isChanged = sites[0].subItems[0].isChanged;
            }
            else {
                const checkedSites = subItems.filter(site => site.checked);
                const isChanged = hasRecordChanged(isOriginalClient, checkedSites.length !== 0);
                sites[0].checked = checkedSites.length !== 0;
                sites[0].unchecked = checkedSites.length === 0;
                sites[0].isChanged = isChanged;
            }
        }

        setContextState({
            data: [...tempData],
            ...contextState
        });
    };

    const handleExpandAllChange = () => {
        if (!isExpandAll) {
            let expandItems = contextState.data.map(item => item.id);
            setContextState({
                ...contextState,
                expanded: [ ...expandItems ]
            });
        } else {
            setContextState({
                ...contextState,
                expanded: []
            });
        }
        
        setIsExpandAll(!isExpandAll);
    };

    const CheckboxCell = props => {
        const { dataItem } = props;
        const field = props.field;        
        let isCheckedAllSites = false;
        let hasSelectedSite = false;

        // show indeterminate when not all options are selected
        if (!isEmpty(dataItem.subItems)) {
            let selected = dataItem.subItems.filter(item => item.checked);
            let notSelected = dataItem.subItems.filter(item => !item.checked);

            if (notSelected.length === dataItem.subItems.length) {
                isCheckedAllSites = true;
            }

            // when no sites are selected, we should show it as unchecked.
            if (selected.length === dataItem.subItems.length) {
                hasSelectedSite = true;
            }
        }

        return (
            <td
                className={props.className} 
                style={dataItem.isClient ? {...props.state, display: 'flex'} : {...props.style, paddingLeft: '40px', display: 'flex'}} 
                expandable={'true'}
            >
                <Checkbox
                    classes={{
                        root: classes.Checkbox
                    }}
                    checked={dataItem.checked ? true : false}
                    onChange={(e) => handleCheckboxChange(e, dataItem)}
                    disabled={isCompanyLevelAccess}
                    indeterminate={dataItem.isClient && !hasSelectedSite ? isCheckedAllSites ? false : true : false}
                    name={field}
                    style={{
                        color:     dataItem.isClient && !hasSelectedSite ? isCheckedAllSites || dataItem.checked ? 'black' : 'red' : 'black',
                        transform: 'scale(1.5)',
                    }}
                    disableRipple
                />
                <span>{dataItem.name}</span>
                {
                    dataItem.isChanged ?
                        <span className="material-icons-outlined" style={{paddingLeft: '2rem'}} >
                            pending_actions
                        </span>
                        : null
                }
            </td>
        );
    };

    const columns = [
        {
            field:      '',
            title:      '',
            width:      '40px',
            filter:     '',
            expandable: 'true'
        },
        {
            field:  'name',
            title:  'Name',
            filter: workbookModeEnabled ? TreeListTextFilter : '',
            cell:   CheckboxCell
        }
    ];

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleCompanyLevelAccessChange = () => {
        let tempData = contextState.data;
        let tempFlag = isCompanyLevelAccess ? false : true;

        if (tempFlag) {
            tempData.forEach(element => {
                element.checked = tempFlag;
                element.subItems.forEach(item => {
                    item.checked = tempFlag;
                });
            });
        }
        
        setIsCompanyLevelAccess(tempFlag);
        setUncheckedCompanyLevelAccess(tempFlag ? false : true);
        setContextState({
            data: [...tempData],
            ...contextState
        });
    };

    let companyName = '';
    if (!isEmpty(selectedUser) && selectedUser.defaultCompanyId && !isEmpty(companies)) {
        let company = companies.filter(item => item.company.id === selectedUser.defaultCompanyId);
        companyName = !isEmpty(company[0]) ? company[0].company.name : 'Not Available';
    }

    return (
        <div className={classes.RolePermission}>
            <div className={classes.RolePermissionFormRow}>
                <div className={classes.RolePermissionFormColumn}>
                    <Checkbox
                        classes={{
                            root: classes.Checkbox
                        }}
                        name={'company'}
                        checked={isCompanyLevelAccess}
                        onChange={(e) => handleCompanyLevelAccessChange(e)}
                        style={{
                            color:     'black',
                            transform: 'scale(1.5)',
                        }}
                        disableRipple
                    />
                    <span>{companyName}</span>
                </div>
            </div>
            {
                !isEmpty(contextState.data) ?
                    <div>
                        <div className={classes.RolePermissionFormRow}>
                            <div style={{paddingRight: '39rem'}}>
                                <Checkbox
                                    classes={{
                                        root: classes.Checkbox
                                    }}
                                    checked={isExpandAll ? true : false}
                                    onChange={(e) => handleExpandAllChange(e)}
                                    name={'expandAll'}
                                    style={{
                                        color:     'black',
                                        transform: 'scale(1.5)',
                                    }}
                                    disableRipple
                                />
                                <span>{isExpandAll ? 'Collapse All' :'Expand All'}</span>
                            </div>
                            <div className={classes.WorkbookModeContainer}>
                                <BobWorkbookModeButton
                                    handleWorkbookMode={handleWorkbookMode}
                                    workbookMode={workbookModeEnabled}
                                />
                            </div>
                        </div>
                        <div className={classes.RolePermissionFormRow}>
                            <style>
                                { kendoGridInlineStyling }
                            </style>
                            <TreeList
                                className={treeListClasses.ContextualTreeList}
                                expandField={expandField} 
                                subItemsField={subItemsField}
                                onExpandChange={onExpandChange} 
                                sortable={{
                                    mode: 'multiple'
                                }} {...contextState.dataState}
                                data={processData()} 
                                onDataStateChange={handleDataStateChange} 
                                columns={columns}
                            />
                        </div>
                    </div> : null 
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        bobLoading:          state.bob.bobLoading,
        companies:           state.core.companies,
        currentUser:         state.currentUser,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...RoleActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextualTab);
